<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">クーポン商品プロモーション設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column" style="width: 880px;">
          <div class="column-list">
            <label class="list-input-title">アイテムコード</label>
            <div class="list-input-content">
              <select #cmb_ItemCode id="cmb_ItemCode" class="combo-box-required" forcedEnabledMode="None" tabindex="0"
                [style.width.px]="175" [(ngModel)]="kymw0908Model.selectedItemCode" 
                (change)="eventItemCode_CHANGEHandler()" [disabled]="isReadOnlyMode() || isDetailMode()">
                <ng-template ngFor let-item [ngForOf]="kymw0908Model.itemCodeList">
                  <option value="{{item.ItemCode}}">{{item.ItemCode}}</option>
                </ng-template>
              </select>
            </div>
          </div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">クーポン種別</label>
              <div class="list-input-content">
                <app-code-combo-box #cmb_CouponTypeList [codeDiv]="'ctp213'"
                  [labelField]="'codeValueName'" id="cmb_CouponTypeList" [subid]="'cmb_CouponTypeList'"
                  class="combo-box-required combo-box" [forcedEnabledMode]="'none'" [required]="true"
                  [(ngModel)]="this.kymw0908Model.couponType" [disabled]="isReadOnlyMode()" [blank]="false">
                </app-code-combo-box>
              </div>
              <label class="list-input-title">注文コード割当コード</label>
              <div class="list-input-content">
                <app-versatile-combo-box
                  [(ngModel)]="kymw0908Model.couponOrderNumQuotaCode" [listSource]="kymw0908Model.couponOrderNumQuotaCodeList"
                  valueField="OrderNumQuotaCode" labelField="OrderNumQuotaName" [tabindex]="0" [visible]="true" [dspBothField]="true"
                  [autofocus]="false" forcedEnabledMode="none" (change)="common_CHANGEHandler();" [required]="true"
                  [style.width.rem]="17" [disabled]="isReadOnlyMode()">
                </app-versatile-combo-box>
              </div>
              <label class="list-input-title">通知有無区分</label>
              <div class="list-input-content">
                <select class="combo-box-required" id="cmb_NotificationFlg"
                  #cmb_NotificationFlg [tabindex]="0" [style.width.%]="'100'" [style.height.%]="'100'"
                  [(ngModel)]="this.kymw0908Model.notificationFlg" [disabled]="isReadOnlyMode()" (change)="setCouponTitleDelivery();">
                  <ng-template ngFor let-item [ngForOf]="this.kymw0908Model.notificationFlgList">
                    <option value="{{item.CodeValue}}">{{item.CodeValueName}}</option>
                  </ng-template>
                </select>
              </div>
              <label class="list-input-title">職員用クーポン</label>
              <div class="list-input-content">
                <app-checkbox-label #chk_StaffCoupon [label]="''" id="chk_StaffCoupon" [disabled]="isReadOnlyMode()"
                [subid]="'chk_StaffCoupon'" [tabindex]="0" [(ngModel)]="this.kymw0908Model.staffCouponFlg">
                </app-checkbox-label>
              </div>
              <label class="list-input-title">クーポン名</label>
              <div class="list-input-content">
                <input type="text" #txti_CouponName id="txti_CouponName" class="text-label-required"
                  plessInputTextCoopDeli [tabindex]="0" [restrict]="'[ -￮]'" [maxlength]="15" [fullOnly]="true" 
                  (input)="couponNameCouponGuideName_CHANGEHandler()" [disabled]="isReadOnlyMode()"
                  [(ngModel)]="this.kymw0908Model.couponName" [style.width.rem]="17"
                  (compositionstart)="onCompStart()" (compositionend)="onCompCouponNameEnd($event)" />
              </div>
              <label class="list-input-title">クーポン名(カナ)</label>
              <div class="list-input-content">
                <input type="text" #txti_CouponNameKana id="txti_CouponNameKana" class="text-label-required"
                  plessInputTextSub [tabindex]="0" [maxlength]="15" [halfOnly]="true" [disabled]="isReadOnlyMode()"
                  [(ngModel)]="this.kymw0908Model.couponNameKana" [style.width.rem]="17"
                  (ngModelChange)="eventCouponNameKana_deleteCommaHandler()" />
              </div>
              <label class="list-input-title">クーポン規格名</label>
              <div class="list-input-content">
                <input type="text" #txti_CouponGuideName id="txti_CouponGuideName"
                  plessInputTextCoopDeli [tabindex]="0" [restrict]="'[ -￮]'" [maxlength]="10" [fullOnly]="true" 
                  (input)="couponNameCouponGuideName_CHANGEHandler();" [disabled]="isReadOnlyMode()"
                  [(ngModel)]="this.kymw0908Model.couponGuideName" [style.width.rem]="12"
                  (compositionstart)="onCompStart()" (compositionend)="onCompCouponGuideNameEnd($event)" />
              </div>
              <label class="list-input-title">クーポン規格名(カナ)</label>
              <div class="list-input-content">
                <input type="text" #txti_CouponGuideNameKana id="txti_CouponGuideNameKana"
                  plessInputTextSub [tabindex]="0" [maxlength]="10" [halfOnly]="true" [disabled]="isReadOnlyMode()"
                  [(ngModel)]="this.kymw0908Model.couponGuideNameKana" [style.width.rem]="12"
                  (ngModelChange)="eventCouponGuideNameKana_deleteCommaHandler()"/>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">グループ</label>
              <div class="list-input-content">
                <app-code-combo-box #cmb_GroupTypeList [codeDiv]="'ctp218'"
                  [labelField]="'codeValueName'" id="cmb_GroupTypeList" [subid]="'cmb_GroupTypeList'"
                  class="combo-box-required disabled-color-required" [forcedEnabledMode]="'none'" [required]="true"
                  [(ngModel)]="this.kymw0908Model.groupType" [disabled]="isReadOnlyMode()" [blank]="false">
                </app-code-combo-box>
              </div>
              <label class="list-input-title">クーポン注文コード</label>
              <div class="list-input-content">
                <input type="text" #txti_CouponOrderNum id="txti_CouponOrderNum"
                  plessInputTextSub [tabindex]="0" readonly [disabled]="isReadOnlyMode()"
                  [(ngModel)]="this.kymw0908Model.couponOrderNum" [style.width.%]="'100'"/>
              </div>
              <label class="list-input-title">通知方法</label>
              <div class="list-input-content">
                <app-checkbox-label #chk_Delivery [label]="'お届け明細'" id="chk_Delivery" [disabled]="isReadOnlyMode()"
                  [subid]="'chk_Delivery'" [tabindex]="0" [(ngModel)]="this.kymw0908Model.deliveryFlg"
                  (change)="setCouponTitleDelivery()">
                </app-checkbox-label>
                <app-checkbox-label #chk_Newsletter [label]="'メルマガ'" id="chk_Newsletter" [disabled]="isReadOnlyMode()"
                  [subid]="'chk_Newsletter'" [tabindex]="0" [(ngModel)]="this.kymw0908Model.newsletterFlg">
                </app-checkbox-label>
              </div>
            </div>
          </div>
          <div class="layout_end">
            <app-radio-label name="grp_CouponDiscountType" label="値引単価" value="1" id="rdb_DiscountUnitPrice" #rdb_DiscountUnitPrice
              [subid]="'rdb_DiscountUnitPrice'" [tabindex]="0" [checked]="true" [disabled]="isReadOnlyMode()"
              [(ngModel)]="this.kymw0908Model.couponDiscountType" (change)="eventCouponDiscountType_CLICKHandler()">
            </app-radio-label>
            <input type="text" #txti_CouponDiscountUnitPrice id="txti_CouponDiscountUnitPrice"
              plessInputTextSub [tabindex]="0" [maxlength]="7" [restrict]="'[0-9]'" 
              [disabled]="kymw0908Model.couponDiscountType !== '1' || isReadOnlyMode()"
              [(ngModel)]="this.kymw0908Model.couponDiscountUnitPrice" [style.width.rem]="6"/>
            <app-radio-label name="grp_CouponDiscountType" label="値引率(%)" value="2" id="rdb_DiscountRate" #rdb_DiscountRate
              [subid]="'rdb_DiscountRate'" [tabindex]="0" [disabled]="isReadOnlyMode()"
              [(ngModel)]="this.kymw0908Model.couponDiscountType" (change)="eventCouponDiscountType_CLICKHandler()">
            </app-radio-label>
            <input type="text" #txti_CouponDiscountRate id="txti_CouponDiscountRate"
              plessInputTextSub [tabindex]="0" [maxlength]="3" [restrict]="'[0-9]'" 
              [disabled]="kymw0908Model.couponDiscountType !== '2' || isReadOnlyMode()"
              [(ngModel)]="this.kymw0908Model.couponDiscountRate" [style.width.rem]="6"/>
            <button #btn_CouponDiscountTypeSetting id="btn_CouponDiscountTypeSetting"
              class="btn-secondary" [tabindex]="0" (click)="eventCouponDiscountTypeSetting_CLICKHandler();setCouponTitleDelivery()">
              値引情報一括設定
            </button>
          </div>
          <div class="layout_end">
            <input type="text" #txti_CouponLimitNum id="txti_CouponLimitNum"
              plessInputTextSub [tabindex]="0" [maxlength]="3" [restrict]="'[0-9]'" [disabled]="isReadOnlyMode()"
              [(ngModel)]="this.kymw0908Model.couponLimitNum" [style.width.rem]="6"/>
            <button #btn_CouponLimitNumSetting id="btn_CouponLimitNumSetting" [disabled]="isReadOnlyMode()"
              class="btn-secondary" [tabindex]="0" (click)="eventCouponLimitNumSetting_CLICKHandler();setCouponTitleDelivery();">
              制限数一括設定
            </button>
          </div>
          <wj-flex-grid #dtg_CouponApplicablePriceList [style.width.%]="100" [style.height.px]="288"
            id="dtg_CouponApplicablePriceList" [tabindex]="0" [itemsSource]="this.kymw0908Model.couponApplicablePriceList"
            [selectionMode]="'Row'" [headersVisibility]="'Column'" [allowDragging]="'None'"
            sortableColumns="false" rowHeight="50" [allowSorting]="false"
            [isReadOnly]="true" [allowResizing]="'Columns'">
            <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="'planGoodsCoopCouponApplicablePriceFlg'" [header]="' '" [align]="'center'" [isReadOnly]="true">
              <!-- 単体チェックボックス -->
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" 
                  [(ngModel)]="cell.item.planGoodsCoopCouponApplicablePriceFlg"
                  id="coupon_applicable_price_list_check_{{cell.row.index}}"
                  (change)="eventcouponApplicablePriceListChk_CLICKHandler();setCoopAllCheck();setCouponTitleDelivery();"
                  forcedEnabledMode="true" [disabled]="isReadOnlyMode() || cell.item.disable"/>
              </ng-template>
              <!-- 一括チェックボックス -->
              <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                <div class="all-target_list-checkbox">
                  <input type="checkbox" id="coupon_applicable_price_list_all_check" #coupon_applicable_price_list_all_check
                    [tabindex]="0" [disabled]="isReadOnlyMode()"
                    (change)="eventAllCoop_CLICKHandler();setCouponTitleDelivery();" [(ngModel)]="kymw0908Model.checkAll" forcedEnabledMode="true"
                    class="headear-checkbox all-target_list-checkbox"/>
                </div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="80" [binding]="'coopName'" [header]="'会員生協'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="115" [binding]="'thisTimeSupplyPrice'" [header]="'供給単価'" [align]="'right'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="160" [binding]="'discountUnitPrice'" [header]="'値引単価'" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="text" plessInputTextSub value="{{cell.item.discountUnitPrice}}"
                  [style.width.%]="'100'" [maxlength]="7" [restrict]="'[0-9]'" style="text-align:right;"
                  [(ngModel)]="cell.item.discountUnitPrice" [tabindex]="0" autocomplete="off" [disabled]="isReadOnlyMode()"
                  (blur)="eventDiscountUnitPrice_FOCUS_OUTHandler(cell.item);setCouponTitleDelivery()"/>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="160" [binding]="'discountRate'" [header]="'値引率(%)'" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="text" plessInputTextSub value="{{cell.item.discountRate}}"
                  [style.width.%]="'100'" [maxlength]="3" [restrict]="'[0-9]'" style="text-align:right;"
                  [(ngModel)]="cell.item.discountRate" [tabindex]="0" autocomplete="off" [disabled]="isReadOnlyMode()"
                  (blur)="eventDiscountRate_FOCUS_OUTHandler(cell.item);setCouponTitleDelivery()"/>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="160" [binding]="'discountedUnitPrice'" [header]="'値引後単価'" [align]="'right'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="147" [binding]="'limitNum'" [header]="'制限数'" [align]="'right'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="text" plessInputTextSub value="{{cell.item.limitNum}}"
                  [style.width.%]="'100'" [maxlength]="3" [restrict]="'[0-9]'" style="text-align:right;" 
                  [disabled]="isReadOnlyMode()" (input)="setCouponTitleDelivery()"
                  [(ngModel)]="cell.item.limitNum" [tabindex]="0" autocomplete="off"/>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
          <div class="column-list">
            <label class="list-input-title">タイトル（EC）</label>
            <div class="list-input-content">
              <app-text-input-coop-deli #txti_CouponTitleEc id="txti_CouponTitleEc" [subid]="'txti_CouponTitleEc'"
                [maxChars]="24" [forcedEnabledMode]="'none'" [tabindex]="0" [displayCountField]="false" [restrict]="'[ -￮]'"
                [fullOnly]="true" [(ngModel)]="this.kymw0908Model.couponTitleEc" [disabled]="isReadOnlyMode()" [style.width.rem]="28" >
              </app-text-input-coop-deli>
            </div>
            <label class="list-input-title">タイトル（お届け明細）</label>
            <div class="list-input-content">
              <app-text-input #txti_CouponTitleDelivery id="txti_CouponTitleDelivery" [subid]="'txti_CouponTitleDelivery'"
                [forcedEnabledMode]="'none'" [tabindex]="0" [displayCountField]="false" [restrict]="'[ -￮]'"[style.width.rem]="28"
                [(ngModel)]="this.kymw0908Model.couponTitleDelivery" [editable]="false" [disabled]="isReadOnlyMode()">
              </app-text-input>
            </div>
            <label class="list-input-title">商品名・規格</label>
            <div class="list-input-content">
              <input type="text" #txti_ContentOne id="txti_ContentOne"
                plessInputTextSub [tabindex]="0" [maxlength]="26" readonly
                [(ngModel)]="this.kymw0908Model.contentOne" [style.width.rem]="28"/>
            </div>
            <label class="list-input-title" style="width: 210px;">値引き前本体価格・税込み価格</label>
            <div class="list-input-content">
              <input type="text" #txti_ContentTwo id="txti_ContentTwo"
                plessInputTextSub [tabindex]="0" [maxlength]="62" readonly
                [(ngModel)]="this.kymw0908Model.contentTwo"/>
            </div>
            <label class="list-input-title" style="width: 210px;">値引き内容</label>
            <div class="list-input-content">
              <input type="text" #txti_ContentThree id="txti_ContentThree"
                plessInputTextSub [tabindex]="0" [maxlength]="32" readonly
                [(ngModel)]="this.kymw0908Model.contentThree"/>
            </div>
            <label class="list-input-title" style="width: 210px;">値引き後本体価格・税込み価格</label>
            <div class="list-input-content">
              <input type="text" #txti_ContentFour id="txti_ContentFour"
                plessInputTextSub [tabindex]="0" [maxlength]="64" readonly
                [(ngModel)]="this.kymw0908Model.contentFour"/>
            </div>
            <label class="list-input-title" style="width: 210px;">有効期限</label>
            <div class="list-input-content">
              <input type="text" #txti_ValidatedDate id="txti_ValidatedDate"
                plessInputTextSub [tabindex]="0" [maxlength]="11" readonly
                [(ngModel)]="this.kymw0908Model.validatedDate" [style.width.rem]="20"/>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" forcedEnabledMode="" class="btn-primary" (click)="eventSet_CLICKHandler()" [disabled]="isReadOnlyMode()"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
